import React from 'react';

import infoSvg from '@assets/img/icons/info.svg';
import { RadioGroupInput } from '@components/Form';
import { ErrorMessage } from '@components/Forms/ErrorMessage';
import { VerticalSpace } from '@components/VerticalSpace';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { formStrings } from '@utils/forms';
import { createStrings } from '@utils/local';
import clsx from 'clsx';

const strings = createStrings({
  ja: {
    useRcepQuestion: 'RCEP（アールセップ）はご利用されますか？',
    rcepHint: () => (
      <>
        RCEPとは？
        <br />
        RCEPとは日本や中国、東南アジア諸国連合（ASEAN）を中心にした16の国家が参加する広範的な貿易協定のことです。
        中国から物品を輸入する際、特定の条件を満たすことで関税率を軽減することができる場合があります。
      </>
    ),
    rcepFileHint: () => (
      <>
        • RCEPの利用には<b>原産地証明書</b>をご用意いただく必要があります。
        原産地証明書は輸出する物品の原産地を証明するための書類で、原則輸出者が用意します。
        <br />• 原産地証明書は<b>本船出港後</b>に取得可能です。
        すみやかにお手続きを進めるため、書類入手後はお早目のアップロードにご協力お願いいたします。
        <br />
        • 原産地証明書のアップロードは『進行中の案件』→
        『通関書類と商品説明をアップロードしてください』→ 『通関書類』画面にて行ってください。
        <br />• 弊社よりRCEP申請し、ご利用不可の場合は弊社D2Dヘルプデスクよりご連絡します。
      </>
    ),
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  tradingAgencyContainer: {
    ...common.textGray700,
    display: 'grid',
    padding: '1rem',
    gridTemplateColumns: '3fr 2fr',
    columnGap: '3rem',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      rowGap: '1rem',
    },
  },
  rcepHintContainer: {
    ...common.flexInline,
    ...common.smallerText,
    ...common.textGray700Important,
    columnGap: '5px',
    marginRight: '2rem',
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
  rcepFileHintContainer: {
    ...common.exSmallerText,
    ...common.textGray700Important,
    columnGap: '1rem',
  },
}));

export const RcepUsageInput: React.FC = () => {
  const classes = { ...useCommonStyles(), ...useStyles() };
  return (
    <div className={classes.tradingAgencyContainer}>
      <div>
        <div className={clsx(classes.middleText)}>
          {strings.useRcepQuestion}
          <span className={classes.textError}>*</span>
        </div>

        <VerticalSpace height={10} />

        <RadioGroupInput
          noLabel
          label=""
          name="use_rcep"
          iconSize="small"
          formControlLabelClasses={{
            label: classes.middleTextImportant,
          }}
          options={[
            {
              value: 'false',
              label: formStrings.notUse,
            },
            {
              value: 'true',
              label: formStrings.use,
            },
          ]}
        />

        <ErrorMessage name="use_rcep" />

        <VerticalSpace height={13} />

        <div className={classes.rcepFileHintContainer}>{strings.rcepFileHint()}</div>
      </div>

      <div className={classes.rcepHintContainer}>
        <div>
          <img
            src={infoSvg}
            style={{ height: 14, width: 14, position: 'relative', top: 2 }}
            alt="Info"
          />
        </div>
        <div>{strings.rcepHint()}</div>
      </div>
    </div>
  );
};
